export default "__VITE_ASSET__BbNujHgY__"